import React from "react";
import { Box, Dialog, Divider, TextField, MenuItem, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import {
  FilterDialogFooter,
  FilterDialogHeader,
} from "../../users/components/filter_dialog/filter_dialog_parts";
import { purple } from "../../../theme/colors";

type Props = {
  open: boolean;
  startDate: string;
  endDate: string;
  selectedModule: string;
  moduleOptions: any;
  onClose: () => void;
  onApply: () => void;
  onClear: () => void;
  setStartDate: (date: string) => void;
  setEndDate: (date: string) => void;
  setSelectedModule: (module: string) => void;
};

export const FilterDialog: React.FC<Props> = ({
  open,
  onClose,
  onApply,
  onClear,
  startDate,
  endDate,
  selectedModule,
  moduleOptions,
  setStartDate,
  setEndDate,
  setSelectedModule,
}) => {
  return (
    <Dialog open={open} onClose={onClose} PaperProps={{ sx: { borderRadius: 3 } }}>
      <Box sx={{ width: 400, maxWidth: "90vw", p: 2 }}>
        <FilterDialogHeader title="Filter Notifications" onClose={onClose} onReset={onClear} />

        <Box sx={{ maxHeight: 400, overflow: "auto" }}>
          <Typography fontSize={16} fontWeight={600} mt={2} mb={1}>
            Date Range
          </Typography>
          <Box display="flex" flexDirection="column" gap={2}>
            <DatePicker
              label="Start Date"
              format="DD-MM-YYYY"
              disableFuture
              value={startDate ? dayjs(startDate, "YYYY-MM-DD") : null}
              onChange={(value: Dayjs | null) =>
                setStartDate(value?.format("YYYY-MM-DD") || "")
              }
              slotProps={{ desktopPaper: { elevation: 3 } }}
              sx={{ "& .MuiSvgIcon-root": { fill: purple } }}
            />
            <DatePicker
              label="End Date"
              format="DD-MM-YYYY"
              disableFuture
              value={endDate ? dayjs(endDate, "YYYY-MM-DD") : null}
              onChange={(value: Dayjs | null) =>
                setEndDate(value?.format("YYYY-MM-DD") || "")
              }
              slotProps={{ desktopPaper: { elevation: 3 } }}
              sx={{ "& .MuiSvgIcon-root": { fill: purple } }}
            />
          </Box>

          <Divider sx={{ mt: 2, mb: 1 }} />

          <Typography fontSize={16} fontWeight={600} mt={1} mb={1}>
            Module
          </Typography>
          <TextField
            select
            fullWidth
            value={selectedModule}
            onChange={(e) => setSelectedModule(e.target.value)}
          >
            <MenuItem value="">All</MenuItem>
            {moduleOptions.map((mod: any) => (
              <MenuItem key={mod.key} value={mod.value}>
                {mod.key}
              </MenuItem>
            ))}
          </TextField>

          <FilterDialogFooter onCancel={onClose} onApply={onApply} applyLabel="Apply Filters" />
        </Box>
      </Box>
    </Dialog>
  );
};
